module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-database-4.9515a77a.svg";